import { AddTeamMembersToGroupByEmailErrorCode } from '../../../types/GloblalTypes';
export var mapAddTeamMembersToGroupByEmailResponse = function (responseData) {
    var _a, _b, _c, _d, _e;
    var toBeInvitedErrorCodeAllowList = [
        AddTeamMembersToGroupByEmailErrorCode.ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_TEAM_MEMBER_NOT_FOUND,
        AddTeamMembersToGroupByEmailErrorCode.ADD_TEAM_MEMBER_TO_GROUP_ERROR_CODE_ACCOUNT_MEMBERSHIP_NOT_FOUND,
    ];
    var successCount = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.successCount) !== null && _a !== void 0 ? _a : 0;
    var membersToInvite = (_c = (_b = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _b === void 0 ? void 0 : _b.filter(function (error) {
        return toBeInvitedErrorCodeAllowList.includes(error.code);
    })) !== null && _c !== void 0 ? _c : [];
    var cannotInviteMembers = (_e = (_d = responseData === null || responseData === void 0 ? void 0 : responseData.errors) === null || _d === void 0 ? void 0 : _d.filter(function (error) { return !toBeInvitedErrorCodeAllowList.includes(error.code); })) !== null && _e !== void 0 ? _e : [];
    return {
        successCount: successCount,
        cannotInviteMembers: cannotInviteMembers,
        emailsOfMembersToInvite: membersToInvite.map(function (member) { return member.email; }),
    };
};
export var mapInviteTeamMembersAndAddToGroupByEmailResponse = function (responseData) {
    var _a, _b, _c;
    var successCount = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.successCount) !== null && _a !== void 0 ? _a : 0;
    var addToGroupErrors = (_b = responseData === null || responseData === void 0 ? void 0 : responseData.addTeamMemberToGroupErrors) !== null && _b !== void 0 ? _b : [];
    var inviteErrors = (_c = responseData === null || responseData === void 0 ? void 0 : responseData.inviteTeamMemberErrors) !== null && _c !== void 0 ? _c : [];
    return {
        successCount: successCount,
        addToGroupErrors: addToGroupErrors,
        inviteErrors: inviteErrors,
    };
};
